<template>
	<v-footer id="nafis-footer" color="#fff" inset>
		<v-container class="pa-1">
			<v-row>
				<v-col cols="12" sm="6" md="3">
					<div>
						<div>درباره ما:</div>
						<div>
							<span class="orange--text ff-emkan-bold">{{ businessTitle }}</span>
							&nbsp;
							<span class="grey--text fs-h5">پلتفرم اعتباری برای خرید کالا و خدمات اقساطی</span>
						</div>
					</div>
				</v-col>
				<v-col cols="12" sm="6" md="2">
					<div>
						<div class="mb-1">شبکه های اجتماعی:</div>
						<a v-if="landingSettings && landingSettings.instagramLink" :href="landingSettings.instagramLink" target="_blank">
							<v-btn fab color="#eeeeee" elevation="1" x-small class="mx-1">
								<v-icon color="orange">mdi-instagram</v-icon>
							</v-btn>
						</a>
						<a v-if="landingSettings && landingSettings.telegramLink" :href="landingSettings.telegramLink" target="_blank">
							<v-btn fab color="#eeeeee" elevation="1" x-small class="mx-1">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" style="fill:orange;width:20px">
									<path d="M66.964 134.874s-32.08-10.062-51.344-16.002c-17.542-6.693-1.57-14.928 6.015-17.59 7.585-2.66 186.38-71.948 194.94-75.233 8.94-4.147 19.884-.35 14.767 18.656-4.416 20.407-30.166 142.874-33.827 158.812-3.66 15.937-18.447 6.844-18.447 6.844l-83.21-61.442z" fill="none" stroke="#ff9a51" stroke-width="20" />
									<path d="M92.412 201.62s4.295.56 8.83-3.702c4.536-4.26 26.303-25.603 26.303-25.603" fill="none" stroke="#ff9a51" stroke-width="20" />
									<path d="M66.985 134.887l28.922 14.082-3.488 52.65s-4.928.843-6.25-3.613c-1.323-4.455-19.185-63.12-19.185-63.12z" fill-rule="evenodd" stroke="#ff9a51" stroke-width="20" stroke-linejoin="bevel" />
									<path d="M66.985 134.887s127.637-77.45 120.09-71.138c-7.55 6.312-91.168 85.22-91.168 85.22z" fill-rule="evenodd" stroke="#ff9a51" stroke-width="9.67" stroke-linejoin="bevel" />
								</svg>
							</v-btn>
						</a>
						<a v-if="landingSettings && landingSettings.whatsappLink" :href="landingSettings.whatsappLink" target="_blank">
							<v-btn fab color="#eeeeee" elevation="1" x-small class="mx-1">
								<v-icon color="orange">mdi-whatsapp</v-icon>
							</v-btn>
						</a>
						<a v-if="landingSettings && landingSettings.rubikaLink" :href="landingSettings.rubikaLink" target="_blank">
							<v-btn fab color="#eeeeee" elevation="1" x-small class="mx-1">
								<v-img class="align-end text-white" contain src="/rubika.png" width="20" style="border-radius: 50%;" />
							</v-btn>
						</a>
						<a v-if="landingSettings && landingSettings.aparatLink" :href="landingSettings.aparatLink" target="_blank">
							<v-btn fab color="#eeeeee" elevation="1" x-small class="mx-1 pa-1">
								<v-img class="align-end text-white" contain src="/aparat.png" width="20" style="border-radius: 50%;" />
							</v-btn>
						</a>
					</div>
				</v-col>
				<v-col cols="12" sm="6" md="4">
					<div>
						<div class="">راه های ارتباطی:</div>
						<v-list nav dense color="transparent">
							<v-list-item>
								<v-list-item-avatar class="ml-0">
									<v-icon color="orange" size="20">
										mdi-map-marker
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="fs-h5 grey--text py-1">{{ address }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar class="ml-0">
									<v-icon color="orange" size="20">
										mdi-cellphone
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="fs-h5 grey--text py-1">{{ phones }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-list-item>
								<v-list-item-avatar class="ml-0">
									<v-icon color="orange" size="20">
										mdi-email
									</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="fs-h5 grey--text">{{ email }}</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</div>
				</v-col>
				<v-col cols="12" sm="6" md="3">
					<div>
						<!-- <img src="https://logo.samandehi.ir/logo.aspx?id=317797&p=qftinbpdyndtyndtbsiyyndt" /> -->
						<a v-if="landingSettings && landingSettings.enamadLink" :href="landingSettings.enamadLink" target="_blank">
							<img src="/enamad.jpg" style="max-width: 90px;margin-right: 10px;border-radius: 15px;" />
						</a>
						<a v-if="landingSettings && landingSettings.etehadieLink" :href="landingSettings.etehadieLink" target="_blank">
							<img src="/logonama.jpg" style="max-width: 90px;margin-right: 10px;border-radius: 15px;" />
						</a>
						<a v-if="landingSettings && landingSettings.samandehiLink" :href="landingSettings.samandehiLink" target="_blank">
							<img src="/samandehipng.jpg" style="max-width: 90px;margin-right: 10px;border-radius: 15px;" />
						</a>
						<a v-if="landingSettings && landingSettings.anjomanSenfiLink" :href="landingSettings.anjomanSenfiLink" target="_blank">
							<img src="/nezamsenfi.jpg" style="max-width: 90px;margin-right: 10px;border-radius: 15px;" />
						</a>
						<a v-if="landingSettings && landingSettings.kasboKarhayeInternetiTehranLink" :href="landingSettings.kasboKarhayeInternetiTehranLink" target="_blank">
							<img src="/kasboKarhayeInternetiTehran.jpg" style="max-width: 90px;margin-right: 10px;border-radius: 15px;" />
						</a>
					</div>
				</v-col>
			</v-row>
		</v-container>
		<div class="text-center grey--text fs-h6 pt-1" style="border-top:1px solid #ddd;width:100%">
			کلیه حقوق این سایت متعلق به {{ businessTitle }} می‌باشد. کپی رایت {{ year }} ©
			<div>
				<small>طراحی و توسعه توسط: <a href="https://jetaqsaat.ir" class="orange--text" target="_blank">جت اقساط</a></small>
			</div>
		</div>
	</v-footer>
</template>

<script>
	// Components
	import { get, call } from 'vuex-pathify'
	import api from '@/util/app-api'
	import Links from '@/components/Links'

	export default {
		name: 'DefaultFooter',

		components: { Links },

		data: () => ({
			errorMessages: '',
			consultantSummeryColor: '',
			consultant: { name: '', phone: '', description: '' },
			consultantLoading: false,
			consultantSummery: '',
		}),
		computed: {
			...get('appSettings', [
				'landingSettings'
			]),
			...get('siteConfig', [
				'isCloud', 'fullTitle'
			]),
			year() {
				let today = new Date().toLocaleDateString('fa-IR')
				return today.substring(0, 4)
			},
			address() {
				return this.landingSettings?.address || ''
			},
			email() {
				return this.landingSettings?.email || ''
			},
			phones() {
				return this.landingSettings?.phones || ''
			},
			businessTitle() {
				return this.landingSettings?.businessTitle || this.fullTitle
			},
		},
		methods: {
			submitConsultant() {
				if (!this.$refs.consultantForm.validate()) { return }

				this.consultantSummery = ''
				this.consultantLoading = true
				this.consultantSummeryColor = ''

				api.post('consultant/create', this.consultant, { authHeader: false })
					.then(response => {
						this.consultantSummery = 'درخواست با موفقیت ثبت شد.'
						this.consultant = { name: '', phone: '', description: '' }
						this.consultantSummeryColor = 'success'
					})
					.catch(err => {
						this.consultantSummery = err.message
						this.consultantSummeryColor = 'error'
					})
					.finally(() => {
						this.consultantLoading = false
					})
			}
		}
	}
</script>
<style>
	.consultantForm .v-input__slot {
		background: #29193c;
	}
</style>
